import { get, map } from 'lodash';

import Model from 'models';
import StoryModuleSlide from 'models/StoryModuleSlide';

const DEFAULT_POSTER_DIMENSION = 300;

const PageSectionStoryModule = class extends Model {
  getDimensions(mediaType, dimension) {
    const cardWithDetailsImage = this.storyModuleCards?.find(card =>
      get(card, `${mediaType}.file.details.image`)
    );
    return get(
      cardWithDetailsImage,
      `${mediaType}.file.details.image.${dimension}`,
      DEFAULT_POSTER_DIMENSION
    );
  }
  get type() {
    return get(this, ['_data', '_contentType']);
  }

  get backgroundColor() {
    return get(this, ['_data', 'backgroundColor']);
  }

  get heading() {
    return get(this, ['_data', 'heading']);
  }

  get mobileCardLayout() {
    return get(this, ['_data', 'mobileCardLayout']);
  }

  get internalName() {
    return get(this, ['_data', 'internalName']);
  }

  get storyModuleCards() {
    return map(get(this, ['_data', 'storyModuleCards']), card => new StoryModuleSlide(card));
  }

  get posterDimensions() {
    return {
      mobile: {
        width: this.getDimensions('mobileMedia', 'width'),
        height: this.getDimensions('mobileMedia', 'height'),
      },
      desktop: {
        width: this.getDimensions('desktopMedia', 'width'),
        height: this.getDimensions('desktopMedia', 'height'),
      },
    };
  }

  get visibility() {
    return get(this, ['_data', 'visibility']);
  }
};

export default PageSectionStoryModule;
